// extracted by mini-css-extract-plugin
export default {"container":"sr-z","heading":"tr-z","text":"ur-z","info":"vr-z","link":"wr-z","fullMaxWidth":"xr-z"};